import { createSlice } from '@reduxjs/toolkit'
import {
  fetchProductDetailsAPI,
  fetchProductsAPI
} from '../actions/productActions'
import { Category } from './categoryReducers'

export type Product = {
  _id: string
  available: number
  rating: number
  name: string
  description: string
  image: string
  price: number
  createdAt: string
  updatedAt: string
  __v: number
  category: Category
}

export interface ProductState {
  success: boolean
  loading: boolean
  products: Array<Product>
  product?: Product
}

const initialState: ProductState = {
  success: false,
  loading: false,
  products: [],
  product: undefined
}
export const productSlices = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },
  },
  extraReducers: builders => {
    builders
      .addCase(fetchProductsAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.products = action.payload.products
        state.loading = false
      })
      .addCase(fetchProductDetailsAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.product = action.payload.product
        state.loading = false
      })
      .addCase(fetchProductDetailsAPI.pending, state => {
        state.loading = true
      })
      .addCase(fetchProductDetailsAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.product = undefined
        state.loading = false
      })
  }
})

export default productSlices.reducer
